import AgendaViewBase from '../AgendaViewBase/AgendaViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import on from 'dojo/on';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import { HtmlHelpers, TranslationHelpers, WindowHelpers } from "../../more/Helpers";
import OE_CheckinForm from './OE_CheckinForm';
import { OMtypes } from "../_loadingHelpers/OM";

class OE_CheckinAgenda extends compose(AgendaViewBase<any>, _TabEnabledMixin) {
	//templateString = template; // Standard verwenden...

 

    _onEmbedding(pageConfig: Tabbing.TabContainerPage, containerName: string) {
   
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<OMtypes.orchestraEmploymentWithCheckin>, rowgroup: StaticTable.StaticTableRowGroup<OMtypes.orchestraEmploymentWithCheckin>) {
        let entity = cell.entity;
        let name = cell.name;

        switch (cell.name) {
            case "tmp_presence_confirmation_availability":
                let statusValue = entity.tmp_presence_confirmation_availability;

                //if (statusValue == "unavailable") {
                //    this.disableNode(cell.tableRow.node);
                //}

                if (entity.ref_associate.ID != this.getCurrentEmployeeId(null, true)) {
                    this.disableNode(cell.tableRow.node);
                }

                let translationsStr = "EmploymentCheckin_Icon__" + statusValue;
                if (TranslationHelpers.canTranslate(translationsStr)) {
                    HtmlHelpers.createFontawesomeIcon(TranslationHelpers.translate(translationsStr), null, cell.contentnode, "only");
                    return true;
                }
                return false;
                break;
        }

        return false;        
    }

    private loadCurrentRelevantCheckins(employeeId: string) {
        let data = {
            "employeeId": employeeId
        };

        this.RequestManager.callfunction(
            "Webtool_API_OrchestraEmploymentCheckin__GetCurrentRelevantCheckins",
            data,
            lang.hitch(this, this._onGetCurrentRelevantCheckins),
            lang.hitch(this, this._onGetCurrentAvaiableCheckinsError)
        );

        this.hourGlassStart(this.sectionTop);
    }

    private _onGetCurrentAvaiableCheckinsError(error: more.requestErrorMessage) {
        this.hourGlassEnd();
    }
    private _onGetCurrentRelevantCheckins(result: Array<string>) {

        
        let row = this.UiModder.domConstruct.create("div", {
            className: "flex_row justify flex_gap"
        });

        this.setContentInTopSection(row);

        if (result?.length) {

            for (let id of result) {
                let container = this.UiModder.domConstruct.create("div", {
                    className: "sectionBG flex_cell_half paddingSmall"
                }, row);

                let checkinform = new OE_CheckinForm();
                checkinform.placeAt(container);
                
                checkinform.setup(id);
                on(checkinform, "saved", lang.hitch(this, this._onSavedCheckin));
            }
        } else {

            let infotxt = this.UiModder.domConstruct.create("p", {
                innerHTML: this.translate("EmploymentCheckin_NoCheckinsAvailable"),
                className: "w3-large infoBG padding-X"
            }, row);
        }

        this.hourGlassEnd(this.sectionTop);
    }
   

    private _onClick_Row(row: StaticTable.StaticTableRow<more.EntityAPIResult>, rowGroup: StaticTable.StaticTableRowGroup<more.EntityAPIResult>) {

        let entity = rowGroup.entity;

        this.openForm(entity);

    }

    openForm(entity: more.EntityAPIResult) {
        if (!entity) return;

        let checkinForm = new OE_CheckinForm();
        checkinForm.show("dlg", null, null);
        checkinForm.setup(entity.ID);
        on(checkinForm, "saved", lang.hitch(this, this._onSavedCheckin));
    }

    protected onReloadData() {
        this.loadCurrentRelevantCheckins(this.getCurrentEmployeeId(null, true));
    }

    private _onSavedCheckin() {
        this.loadData();
        this.loadCurrentRelevantCheckins(this.getCurrentEmployeeId(null, true));
    }
   
    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        
        this.RequestManager.handleAs = "jsonWithDate";

        this.setupAgendaViewWithCallfunction(
            "Webtool_API_OrchestraEmploymentCheckin__GetAgendaFilterOptions",
            "Webtool_API_OrchestraEmploymentCheckin__GetEmploymentsAgenda",
            lang.hitch(this, this._onClick_Row),
            this._tableFormatter,
            null
        );

        WindowHelpers.setTitles("EmploymentCheckin_MainTitle");      
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        if (window.sessionInfo.isSubstitutionActive()) {
            this.disableNode(this.domNode);

        } else {
            this.getCurrentEmployeeId(lang.hitch(this, this.loadCurrentRelevantCheckins), true);
        }
    }
}

export default mdsWidget(OE_CheckinAgenda);